import { render, staticRenderFns } from "./SalePage.vue?vue&type=template&id=82514c64&"
import script from "./SalePage.vue?vue&type=script&lang=js&"
export * from "./SalePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports